module.exports = __webpack_public_path__ + "img/redPacket.cc4728a5.png";